import type {
  FareSliceDetailsV2,
  TripSegment,
  TripSlice,
} from "@b2bportal/air-shopping-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { I18nMarkup, useI18nContext } from "@hopper-b2b/i18n";
import { removeTimezone } from "@hopper-b2b/utilities";
import { FareDetails, FlightDetails } from "@tenant/flights";
import { Button, Dialog, DialogContent } from "@tenant/ui";
import dayjs from "dayjs";
import styles from "./FlightDetailsDialog.module.scss";

export const FlightDetailsDialog = ({
  open,
  onClose,
  onClick,
  flightSlice,
  isOutbound,
  fareSlice,
  segments,
}: {
  open: boolean;
  flightSlice?: TripSlice;
  isOutbound: boolean;
  onClose: () => void;
  onClick: () => void;
  fareSlice?: FareSliceDetailsV2;
  segments?: TripSegment[];
}) => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightDetailsDialog;
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t, formatDateTime, DateTimeFormatStyle } = useI18nContext();

  if (flightSlice == null || !open) {
    // we don't have a flight slice or the dialog is not open
    return null;
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogContent
        title={
          <I18nMarkup
            className={cn("title")}
            tKey={
              isOutbound
                ? "core-flights.flightDetailsTitle.detailsOutbound"
                : "core-flights.flightDetailsTitle.detailsReturn"
            }
            replacements={{
              date: formatDateTime(
                dayjs(removeTimezone(flightSlice.departureTime)).toDate(),
                DateTimeFormatStyle.ShortMonthDayShortWeekday
              ),
              city: flightSlice.destinationName,
            }}
          />
        }
        className={block}
        bottomFixedContent={
          <Button className={cn("continue-button")} onClick={onClick}>
            {t("continue")}
          </Button>
        }
      >
        <FlightDetails flightSlice={flightSlice} isOutgoing={isOutbound} />
        {fareSlice != null && segments != null && (
          <div className={cn("fare-class-card")}>
            <FareDetails
              fareSlice={fareSlice}
              segments={segments}
              showAllFareDetails={false}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
